<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-sixe:15px; font-weight: bold">update truck tracking</small>
      </legend>
      <div>
        <form @submit.prevent="updateTrucktracking()">
          <div class="row">
            <input type="hidden" class="id" :value="Trucktracking.id" />
            <input type="hidden" class="requisition_id" :value="Trucktracking.requisition_id" />
              <div class="col-md-6">
              <div class="form-group">
                <label>Tracking date</label>
                <input
                  type="date"
                  class="form-contro tracking_date input-rounded f-s-14"
                  placeholder="tracking date"
                  :value="Trucktracking.tracking_date"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Truck location</label>
                <input
                  type="text"
                  class="form-control truck_location input-rounded f-s-14"
                  placeholder="truck collection"
                  :value="Trucktracking.truck_location"
                  required
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat updatingTrucktracking btn-rounded">
            <i class="fa fa-plus"></i> update tracking
          </button>
          <button type="button" class="btn btn-primary btn-flat updatingTrucktrackingLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Bondtracking.length === 0) {
      router.push("/managetrucktrackings");
    }
  },
  computed: {
    ...mapGetters(["Trucktracking"])
  },
  methods: {
    ...mapActions(["updateTrucktracking"])
  }
};
</script>
<style scoped>
.updatingTrucktrackingLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/trucktrackings/updatetrucktracking.vue